// import React, { useRef, useState } from "react";

// /* ─── Variant data — exact from original page ─────────────────────────── */
// const VARIANTS = [
  
//   {
//     id: 2,
//     name: "MAJESTOR 4X4 7STR SAVVY",
//     img: "https://mgmotor.scene7.com/is/image/mgmotor/chooseyourmajestor-img-001?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&hei=1080",
//     reserveHref: "/vehicles/mg-majestor-biggest-suv-india/pre-reserve",
//   },
//   {
//     id: 3,
//     name: "MAJESTOR 4X2 6STR SAVVY",
//     img: "https://mgmotor.scene7.com/is/image/mgmotor/chooseyourmajestor-img-001?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&hei=1080",
//     reserveHref: "/vehicles/mg-majestor-biggest-suv-india/pre-reserve",
//   },
//   {
//     id: 4,
//     name: "MAJESTOR 4X2 7STR SAVVY",
//     img: "https://mgmotor.scene7.com/is/image/mgmotor/chooseyourmajestor-img-001?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&hei=1080",
//     reserveHref: "/vehicles/mg-majestor-biggest-suv-india/pre-reserve",
//   },
// ];

// /* ─── Arrow icon ──────────────────────────────────────────────────────── */
// const DiagArrow = ({ size = 13, color = "currentColor" }) => (
//   <svg
//     width={size} height={size} viewBox="0 0 24 24" fill="none"
//     stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
//     style={{ flexShrink: 0 }}
//   >
//     <line x1="7" y1="17" x2="17" y2="7" />
//     <polyline points="7 7 17 7 17 17" />
//   </svg>
// );

// /* ─── Main component ──────────────────────────────────────────────────── */
// export default function MajestorVariants() {
//   const scrollRef = useRef(null);

//   /* Touch-drag scroll for mobile */
//   const dragRef = useRef({ on: false, x: 0, scrollL: 0 });
//   const onMouseDown = (e) => {
//     dragRef.current = { on: true, x: e.clientX, scrollL: scrollRef.current.scrollLeft };
//   };
//   const onMouseMove = (e) => {
//     if (!dragRef.current.on) return;
//     const dx = e.clientX - dragRef.current.x;
//     scrollRef.current.scrollLeft = dragRef.current.scrollL - dx;
//   };
//   const onMouseUp = () => { dragRef.current.on = false; };

//   return (
//     <>
//       <style>{`
//         /* ── Reset scoped ── */
//         .mjv, .mjv * { box-sizing: border-box; margin: 0; padding: 0; }

//         /* ── Section ── */
//         .mjv {
//           background: #efefef;
//           font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
//           padding: 64px 0 72px;
//           overflow: hidden;
//           text-align: center;
//         }

//         /* ── Section title ── */
//         .mjv-title {
//           font-size: clamp(24px, 3.2vw, 48px);
//           font-weight: 900;
//           font-style: italic;
//           letter-spacing: 0.04em;
//           color: #111;
//           line-height: 1.1;
//           /* Horizontal padding same as cards outer container */
//           padding: 0 clamp(20px, 5vw, 80px);
//           margin-bottom: clamp(36px, 5vw, 64px);
//         }

//         /* ── Cards scroll wrapper ──
//            On desktop: 4 equal columns, no overflow.
//            On tablet/mobile: horizontal scroll with hidden scrollbar.
//         ── */
//         .mjv-scroll {
//           display: flex;
//           justify-content:center;
//           align-items: stretch;
//           overflow-x: auto;
//           scroll-behavior: smooth;
//           -webkit-overflow-scrolling: touch;
//           cursor: grab;
//           /* Hide scrollbar cross-browser */
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }
//         .mjv-scroll::-webkit-scrollbar { display: none; }
//         .mjv-scroll.dragging { cursor: grabbing; }

//         /* ── Individual card ── */
//         .mjv-card {
//           /*
//             Desktop: exactly 25% so 4 cards fill the row.
//             We use flex: 1 1 25% with min-width to force scroll on small screens.
//           */
//           flex: 0 0 25%;
//           min-width: 260px;           /* triggers horizontal scroll on mobile */
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           padding: 0 clamp(16px, 2.5vw, 44px);
//           /* Divider between cards — 1px #dcdcdc, not on last */
//           border-right: 1px solid #dcdcdc;
//           position: relative;
//         }
//         .mjv-card:last-child {
//           border-right: none;
//         }

//         /* ── Car image ── */
//         .mjv-img {
//           width: 100%;
//           height: auto;
//           display: block;
//           /* Slightly overlap to remove dead-space above car body */
//           margin-bottom: 0;
//           object-fit: contain;
//           /* Consistent height so all cards align at same level */
//           max-height: 220px;
//         }

//         /* ── Variant name ── */
//         .mjv-name {
//           font-size: clamp(15px, 1.5vw, 22px);
//           font-weight: 900;
//           font-style: italic;
//           color: #111;
//           letter-spacing: 0.02em;
//           line-height: 1.2;
//           margin: clamp(20px, 2.5vw, 32px) 0 clamp(16px, 2vw, 24px);
//           text-align: center;
//         }

//         /* ── Reserve button ── */
//         .mjv-reserve {
//           display: inline-flex;
//           align-items: center;
//           gap: 7px;
//           background: #d71920;
//           color: #fff;
//           font-size: clamp(12px, 1vw, 14px);
//           font-weight: 700;
//           letter-spacing: 0.08em;
//           text-decoration: none;
//           padding: clamp(10px, 1.2vw, 14px) clamp(20px, 2.5vw, 34px);
//           border-radius: 5px;
//           transition: background 0.22s ease;
//           white-space: nowrap;
//           /* Push to bottom of card */
//           margin-top: auto;
//         }
//         .mjv-reserve:hover { background: #b31217; }

//         /* ── Compare button ── */
//         .mjv-compare-wrap {
//           margin-top: clamp(40px, 5vw, 72px);
//           padding: 0 clamp(20px, 5vw, 80px);
//         }
//         .mjv-compare {
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           background: #d71920;
//           color: #fff;
//           font-size: clamp(13px, 1.1vw, 16px);
//           font-weight: 800;
//           letter-spacing: 0.08em;
//           text-decoration: none;
//           padding: clamp(14px, 1.5vw, 18px) clamp(30px, 4vw, 60px);
//           border-radius: 5px;
//           transition: background 0.22s ease;
//           white-space: nowrap;
//         }
//         .mjv-compare:hover { background: #b31217; }

//         /* ── Tablet: 2 cards visible, min-width smaller ── */
//         @media (max-width: 1024px) and (min-width: 641px) {
//           .mjv { padding: 48px 0 60px; }
//           .mjv-card {
//             flex: 0 0 50%;
//             min-width: 280px;
//           }
//           .mjv-img { max-height: 180px; }
//         }

//         /* ── Mobile: 1.4 cards visible with peek ── */
//         @media (max-width: 640px) {
//           .mjv { padding: 36px 0 48px; }
//           .mjv-card {
//             flex: 0 0 78vw;
//             min-width: 240px;
//             padding: 0 16px;
//           }
//           .mjv-img { max-height: 160px; }
//           .mjv-compare { width: 100%; justify-content: center; }
//         }

//         /* ── Large desktop: constrain max width ── */
//         @media (min-width: 1600px) {
//           .mjv-img { max-height: 260px; }
//         }
//       `}</style>

//       <section className="mjv">

//         {/* ── Title ── */}
//         <h2 className="mjv-title">CHOOSE YOUR MAJESTOR</h2>

//         {/* ── Cards row ── */}
//         <div
//           ref={scrollRef}
//           className="mjv-scroll"
//           onMouseDown={onMouseDown}
//           onMouseMove={onMouseMove}
//           onMouseUp={onMouseUp}
//           onMouseLeave={onMouseUp}
//         >
//           {VARIANTS.map((v) => (
//             <div className="mjv-card" key={v.id}>

//               {/* Car image */}
//               <img
//                 className="mjv-img"
//                 src={v.img}
//                 alt={v.name}
//                 draggable={false}
//               />

//               {/* Variant name */}
//               <h2 className="mjv-name">{v.name}</h2>

//               {/* Reserve button */}
//               {/* <a
//                 className="mjv-reserve"
//                 href={v.reserveHref}
//               >
//                 RESERVE <DiagArrow size={12} color="#fff" />
//               </a> */}

//             </div>
//           ))}
//         </div>

//         {/* ── Compare button ── */}
//         {/* <div className="mjv-compare-wrap">
//           <a
//             className="mjv-compare"
//             href="/tools/car-comparison"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             COMPARE THESE VARIANTS <DiagArrow size={13} color="#fff" />
//           </a>
//         </div> */}

//       </section>
//     </>
//   );
// }


































import React, { useRef, useState, useEffect, useCallback } from "react";

const VARIANTS = [
  { id: 2, name: "MAJESTOR 4X4 7STR SAVVY", img: "https://mgmotor.scene7.com/is/image/mgmotor/chooseyourmajestor-img-001?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&hei=1080" },
  { id: 3, name: "MAJESTOR 4X2 6STR SAVVY", img: "https://mgmotor.scene7.com/is/image/mgmotor/chooseyourmajestor-img-001?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&hei=1080" },
  { id: 4, name: "MAJESTOR 4X2 7STR SAVVY", img: "https://mgmotor.scene7.com/is/image/mgmotor/chooseyourmajestor-img-001?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&hei=1080" },
];

export default function MajestorVariants() {
  const scrollRef = useRef(null);
  const timerRef = useRef(null);
  const dragRef = useRef({ on: false, x: 0, scrollL: 0 });
  const [current, setCurrent] = useState(0);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);

  const getCardWidth = () => {
    const card = scrollRef.current?.querySelector(".mjv-card");
    return card ? card.offsetWidth : 0;
  };

  const goTo = useCallback((idx) => {
    const total = VARIANTS.length;
    const next = ((idx % total) + total) % total;
    setCurrent(next);
    scrollRef.current?.scrollTo({ left: next * getCardWidth(), behavior: "smooth" });
  }, []);

  const startAuto = useCallback(() => {
    if (window.innerWidth > 1024) return;
    timerRef.current = setInterval(() => {
      setCurrent((prev) => {
        const next = (prev + 1) % VARIANTS.length;
        scrollRef.current?.scrollTo({ left: next * getCardWidth(), behavior: "smooth" });
        return next;
      });
    }, 3000);
  }, []);

  const stopAuto = useCallback(() => clearInterval(timerRef.current), []);
  const resetAuto = useCallback(() => { stopAuto(); startAuto(); }, [stopAuto, startAuto]);

  useEffect(() => {
    startAuto();
    const onResize = () => {
      const desktop = window.innerWidth > 1024;
      setIsDesktop(desktop);
      clearInterval(timerRef.current);
      if (!desktop) startAuto();
      else { scrollRef.current?.scrollTo({ left: 0 }); setCurrent(0); }
    };
    window.addEventListener("resize", onResize);
    return () => { clearInterval(timerRef.current); window.removeEventListener("resize", onResize); };
  }, [startAuto]);

  const onMouseDown = (e) => {
    dragRef.current = { on: true, x: e.clientX, scrollL: scrollRef.current.scrollLeft };
    stopAuto();
  };
  const onMouseMove = (e) => {
    if (!dragRef.current.on) return;
    scrollRef.current.scrollLeft = dragRef.current.scrollL - (e.clientX - dragRef.current.x);
  };
  const onMouseUp = () => {
    if (dragRef.current.on && !isDesktop) {
      const idx = Math.round(scrollRef.current.scrollLeft / getCardWidth());
      goTo(Math.max(0, Math.min(idx, VARIANTS.length - 1)));
      resetAuto();
    }
    dragRef.current.on = false;
  };
  const onTouchEnd = () => {
    const idx = Math.round(scrollRef.current.scrollLeft / getCardWidth());
    setCurrent(Math.max(0, Math.min(idx, VARIANTS.length - 1)));
    resetAuto();
  };

  return (
    <>
      <style>{`
        .mjv, .mjv * { box-sizing: border-box; margin: 0; padding: 0; }
        .mjv { background: #efefef; font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif; padding: 64px 0 72px; overflow: hidden; text-align: center; }
        .mjv-title { font-size: clamp(24px, 3.2vw, 48px); font-weight: 900; font-style: italic; letter-spacing: 0.04em; color: #111; line-height: 1.1; padding: 0 clamp(20px, 5vw, 80px); margin-bottom: clamp(36px, 5vw, 64px); }
        .mjv-scroll { display: flex; justify-content: center; align-items: stretch; overflow-x: auto; scroll-behavior: smooth; -webkit-overflow-scrolling: touch; cursor: grab; scrollbar-width: none; -ms-overflow-style: none; }
        .mjv-scroll::-webkit-scrollbar { display: none; }
        .mjv-card { flex: 0 0 25%; min-width: 260px; display: flex; flex-direction: column; align-items: center; padding: 0 clamp(16px, 2.5vw, 44px); border-right: 1px solid #dcdcdc; }
        .mjv-card:last-child { border-right: none; }
        .mjv-img { width: 100%; height: auto; display: block; object-fit: contain; max-height: 220px; }
        .mjv-name { font-size: clamp(15px, 1.5vw, 22px); font-weight: 900; font-style: italic; color: #111; letter-spacing: 0.02em; line-height: 1.2; margin: clamp(20px, 2.5vw, 32px) 0 clamp(16px, 2vw, 24px); text-align: center; }
        .mjv-dots { display: none; justify-content: center; gap: 8px; margin-top: 28px; }
        .mjv-dot { width: 8px; height: 8px; border-radius: 50%; background: #ccc; border: none; padding: 0; cursor: pointer; transition: background 0.2s, transform 0.2s; }
        .mjv-dot.active { background: #d71920; transform: scale(1.3); }
        @media (max-width: 1024px) {
          .mjv { padding: 48px 0 60px; }
          .mjv-scroll { justify-content: flex-start; }
          .mjv-card { flex: 0 0 78vw; min-width: 240px; padding: 0 20px; }
          .mjv-img { max-height: 180px; }
          .mjv-dots { display: flex; }
        }
        @media (max-width: 640px) {
          .mjv { padding: 36px 0 48px; }
          .mjv-card { flex: 0 0 85vw; min-width: 220px; padding: 0 16px; }
          .mjv-img { max-height: 160px; }
        }
        @media (min-width: 1600px) { .mjv-img { max-height: 260px; } }
      `}</style>

      <section className="mjv">
        <h2 className="mjv-title">CHOOSE YOUR MAJESTOR</h2>

        <div
          ref={scrollRef}
          className="mjv-scroll"
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseUp}
          onMouseEnter={stopAuto}
          onTouchStart={stopAuto}
          onTouchEnd={onTouchEnd}
        >
          {VARIANTS.map((v) => (
            <div className="mjv-card" key={v.id}>
              <img className="mjv-img" src={v.img} alt={v.name} draggable={false} />
              <h2 className="mjv-name">{v.name}</h2>
            </div>
          ))}
        </div>

        {/* Dot indicators — visible only on mobile/tablet */}
        <div className="mjv-dots">
          {VARIANTS.map((_, i) => (
            <button
              key={i}
              className={`mjv-dot${i === current ? " active" : ""}`}
              aria-label={`Slide ${i + 1}`}
              onClick={() => { goTo(i); resetAuto(); }}
            />
          ))}
        </div>
      </section>
    </>
  );
}